// extracted by mini-css-extract-plugin
export default {"grid":"mark-as-paid-modal_grid__bXfMM","col":"mark-as-paid-modal_col__tcbiy"};